import $ from "jquery";

const career = function () {
  const tabsWrapper = $(this).find(".tabs__wrapper");
  const radios = tabsWrapper.find('input[type="radio"]');
  const tabs = tabsWrapper.find(".tab");

  radios.each(function (index) {
    $(this).attr("data-tab", index);
  });
  tabs.each(function (index) {
    $(this).attr("data-tab", index);
  });

  switchTabs(
    radios
      .filter(function () {
        return $(this).is(":checked");
      })
      .data("tab"),
    tabs
  );

  radios.off("click");
  radios.on("click", function () {
    switchTabs($(this).data("tab"), tabs);
  });
};

const switchTabs = (tabNum, tabs) =>
  tabs.each(function () {
    const tab = $(this);
    tab.data("tab") == tabNum ? tab.slideDown() : tab.slideUp();
  });

export const reloadScriptCareerDefault = () => $(".career__form").each(career);
reloadScriptCareerDefault();
